import { ErrorMessage } from '@hookform/error-message'
import { DatePickerInput, Hint } from '@tecsinapse/cortex-react'
import React from 'react'
import { useController, useFormContext } from 'react-hook-form'

interface FormDateFieldProps {
  name: string
  label?: string
  granularity?: 'day' | 'hour' | 'minute' | 'second'
  minValue?: Date
}

export const FormDateField = ({
  name,
  label,
  granularity,
  minValue
}: FormDateFieldProps) => {
  const { control, setValue } = useFormContext()
  const {
    field: { value: _value },
    formState: { errors, submitCount },
    fieldState: { error, isTouched }
  } = useController({ name, control })

  const value =
    _value instanceof Date || _value === undefined || _value === null
      ? _value
      : new Date(_value)

  return (
    <div className={'w-full flex flex-col'}>
      <DatePickerInput
        variants={{ intent: error ? 'error' : 'default' }}
        onChange={date => {
          setValue(name, date, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: true
          })
        }}
        value={value ?? undefined}
        label={label}
        granularity={granularity ?? 'day'}
        hourCycle={24}
        minValue={minValue}
      />
      {(isTouched || submitCount > 0) && error ? (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <Hint variants={{ intent: 'error' }}>{String(message)}</Hint>
          )}
        />
      ) : null}
    </div>
  )
}

export default FormDateField
